<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-toolbar-title>Blister Scrap Lines</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-dialog
        v-model="dialog"
        max-width="700px"
        scrollable
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                >
                  <v-autocomplete
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    flat
                    placeholder="Select only suggested BOM Type"
                    :items="bomTypes"
                    v-model="editedItem.type"
                    label="Type"
                    @change="bomTypeSelect"
                    auto
                    chips
                    prepend-icon="spellcheck"
                    required
                    item-text="text"
                    item-value="value"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                >
                  <v-autocomplete
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    flat
                    placeholder="Select only suggested Production Order No"
                    :items="sourceItems"
                    v-model="editedItem.prodOrderNo"
                    label="No."
                    @change="prodSelect"
                    auto
                    chips
                    prepend-icon="notes"
                    required
                    item-text="description"
                    item-value="no"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <v-chip
                        :selected="data.selected"
                        class="chip--select-multi"
                      >
                        {{ data.item.no }}
                      </v-chip>
                    </template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                      </template>
                      <template v-else>

                        <v-list-tile-content>
                          <v-list-tile-title v-html="data.item.no"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </template>

                  </v-autocomplete>
                </v-flex>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-autocomplete
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    flat
                    placeholder="Select only suggested Calculation Type"
                    :items="calculationTypes"
                    v-model="editedItem.calculationType"
                    label="Calculation Type"
                    @change="calTypeSelect"
                    auto
                    chips
                    prepend-icon="spellcheck"
                    required
                    item-text="text"
                    item-value="value"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.addonQty"
                    type="number"
                    prepend-icon="account_balance_wallet"
                    label="Add-on Quantity "
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.qtyPer"
                    type="number"
                    prepend-icon="account_balance_wallet"
                    label="Quantity Per"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    v-model="editedItem.scrapPercentage"
                    prepend-icon="landscape"
                    suffix="%"
                    type="number"
                    label="Scrap Percentage"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-autocomplete
                    clearable
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    flat
                    :items="uoms"
                    @change="uomSelect"
                    v-model="editedItem.uom"
                    label="UOM"
                    auto
                    chips
                    prepend-icon="spellcheck"
                    required
                    item-text="code"
                    item-value="code"
                  ></v-autocomplete>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-checkbox
                    v-model="editedItem.qCInheritance"
                    label="QC Inheritance"
                  ></v-checkbox
                    </v-flex>
                    <v-flex
                    xs12
                    sm6
                    md4
                  >
                  <v-checkbox
                    v-model="editedItem.inheritance"
                    label="Inheritance"
                  ></v-checkbox>
                </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="close"
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="save"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="scrapLines"
      :search="search"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.typeText }}</td>
        <td>{{ props.item.prodOrderNo }}</td>
        <td>{{ props.item.description }}</td>
        <!-- <td>{{ props.item.calculationTypeText }}</td> -->
        <td>{{ props.item.addonQty }}</td>
        <td>{{ props.item.qtyPer }}</td>
        <td>{{ props.item.uom }}</td>
        <td>{{ props.item.scrapPercentage }}</td>
        <td>
          <v-checkbox
            primary
            hide-details
            v-model="props.item.qCInheritance"
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            primary
            hide-details
            v-model="props.item.inheritance"
          ></v-checkbox>
        </td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <!-- <v-btn
          color="primary"
          @click="initialize"
        >Reset</v-btn> -->
        no records added.
      </template>
    </v-data-table>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>

  </div>
</template>
<script>
import { getblisterLines } from '@/api/blisterScrapLine';
import { getUOM, getMachine, getItems, getItemUOM } from '@/api/navService';

export default {
  data: () => ({
    dialog: false,
    blisterScrapId: -1,
    search: '',
    loader: false,
    bomTypes: [
      { text: 'Item', value: 'Item' },
      { text: 'Production BOM', value: 'Production BOM' },

    ],
    calculationTypes: [
      { text: 'Standard', value: 300 },
      { text: 'Add-on', value: 301 },
      { text: 'unit per Batch', value: 302 },
    ],
    uoms: [

    ],
    sourceItems: [

    ],
    items: [

    ],
    headers: [
      {
        text: 'Type',
        align: 'left',
        sortable: true,
        value: 'type'
      },
      {
        text: 'No.',
        align: 'left',
        value: 'no'
      },
      { text: 'Description ', value: 'description' },
      // { text: 'Calculation Type', value: 'calculation' },
      { text: 'Add-on Quantity', value: 'addonQty' },
      { text: 'Quantity per', value: 'quantity' },
      { text: 'UOM', value: 'uom' },
      { text: 'Scrap Percentage (%)', value: 'scrapPPer' },
      { text: 'QC Inheritance', value: 'QC' },
      { text: 'Inheritance', value: 'Inheritance' },
      { text: 'Action', value: 'action', align: 'right' }
    ],
    selectedItem: [],
    scrapLines: [],
    editedIndex: -1,
    editedItem: {
      type: 301,
      blisterScrapId: -1,
      typeText: 'Item',
      prodOrderNo: '',
      prodOrderNoText: '',
      description: '',
      calculationType: -1,
      calculationTypeText: '',
      addonQty: 0,
      qtyPer: 0,
      uOM: '',
      uOMText: '',
      scrapPercentage: 0,
      qCInheritance: false,
      inheritance: false
    },
    defaultItem: {
      type: 301,
      blisterScrapId: -1,
      typeText: 'Item',
      prodOrderNo: '',
      prodOrderNoText: '',
      description: '',
      calculationType: -1,
      calculationTypeText: '',
      addonQty: 0,
      qtyPer: 0,
      uom: '',
      uOMText: '',
      scrapPercentage: 0,
      qCInheritance: false,
      inheritance: false
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
    this.navFunc();
  },

  methods: {
    navFunc () {

    },
    remove (item) {
      const index = this.sourceItems.indexOf(item.no)
      if (index >= 0) this.sourceItems.splice(index, 1)
      this.prodOrderNo = null;
    },
    initialize () {
      this.loader = true;
      if (this.blisterScrapId != -1) {
        getblisterLines(this.blisterScrapId)
          .then(response => {
            this.scrapLines = response.data;
            this.loader = false;

          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
      getItems()
        .then(response => {
          this.sourceItems = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getUOM()
        .then(response => {
          this.uoms = response.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    editItem (item) {
      this.editedIndex = this.scrapLines.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },


    deleteItem (item) {
      const index = this.scrapLines.indexOf(this.selectedItem);
      this.$refs.deleteConfirmationDialog.close();
      this.scrapLines.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.scrapLines[this.editedIndex], this.editedItem);
      } else {
        this.scrapLines.push(this.editedItem);
      }
      this.close();
    },

    uomSelect (label) {
      // let uom = this.uoms.filter(o => o.code == label);
      //this.editedItem.uOMText = label;
    },
    calTypeSelect (label) {
      // let uom = this.calculationTypes.filter(o => o.value == label);
      // this.editedItem.calculationTypeText = uom[0].text;
    },
    prodSelect (label) {
      let uom = this.sourceItems.filter(o => o.no == label);
      console.log(uom);
      this.editedItem.description = uom[0].description;
      this.loader = true;
      getItemUOM(label)
        .then(response => {
          this.uoms = response.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    bomTypeSelect (label) {
      // let uom = this.bomTypes.filter(o => o.value == label);
      // this.editedItem.typeText = uom[0].text;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterScrapLines.vue